import React, { useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { CardContext } from "../context/CardContext";
import { BaseContext } from "../context/BaseContext";

const baseLabels = { nevskiy88: "Невский, 88", novaya: "ЮрБюро 88" };

export const Navbar = () => {
  const card = useContext(CardContext);
  const auth = useContext(AuthContext);
  const { base } = useContext(BaseContext);
  const history = useHistory();

  var path = useLocation().pathname;
  path = path.slice(1, path.length);
  const findPath = path.indexOf("/");
  if (findPath !== -1) {
    path = path.slice(0, findPath);
  }

  // На формах карточки любой уход с формы подтверждается
  const onForm = path === "add" || path === "edit";
  const guardArmed = onForm && !!card.homeConfirm;

  const openConfirm = (target) => {
    card.setPendingTarget(target);
    card.homeConfirm();
  };

  const logoutHandler = (event) => {
    if (guardArmed) {
      event.preventDefault();
      openConfirm("logout");
      return;
    }
    auth.logout();
    history.push("/");
  };

  const goHome = (event) => {
    event.preventDefault();
    if (guardArmed) {
      openConfirm("/bases");
      return;
    }
    history.push("/bases");
  };

  const interceptLink = (event, to) => {
    if (guardArmed) {
      event.preventDefault();
      openConfirm(to);
    }
  };

  let links = [
    { to: "/add", caption: "Добавить клиента" },
    { to: "/search", caption: "Поиск по базе" },
    { to: "/cards", caption: "База" },
    { to: "/costs", caption: "Счета" },
  ];

  // На странице выбора базы скрываем меню и показываем подпись в центре
  const onBasesPage = path === "bases";
  const brandLabel = onBasesPage ? "Выбор базы" : (base ? baseLabels[base] || base : "");

  return (
    <nav>
      <div
        className="nav-wrapper blue darken-1"
        style={{ padding: "0 2rem" }}
      >
        <span
          className="brand-logo center"
          style={{ fontSize: onBasesPage ? "2rem" : "2.8rem" }}
        >
          {brandLabel}
        </span>
        <a href="/" className="right" onClick={logoutHandler}>
          Выйти
        </a>
        {!onBasesPage && (
        <ul id="nav-mobile" className="left hide-on-med-and-down">
          <li>
            <a
              href="#"
              onClick={goHome}
              title="Домой"
              style={{ fontSize: "32px", lineHeight: "64px", padding: "0 10px" }}
            >
              🏠
            </a>
          </li>
          {links.map((link) => {
            return (
              <li key={link.to}>
                <NavLink onClick={(e) => interceptLink(e, link.to)} to={link.to}>
                  {link.caption}
                </NavLink>
              </li>
            );
          })}
        </ul>
        )}
      </div>
    </nav>
  );
};